import { TableCard } from "@general-backoffice/core";
import type { PaginationMeta } from "@investhinks/api-client";
import React from "react";

interface PaginatedTableFooterProps {
  isLoading: boolean;
  pagination?: PaginationMeta | null;
  goToPage: (page: number) => void;
  changePageSize?: (size: number) => void;
  amountOptions?: number[];
}

const PaginatedTableFooter: React.FC<PaginatedTableFooterProps> = ({
  isLoading,
  pagination,
  goToPage,
  changePageSize = () => {},
  amountOptions = [5, 10, 25, 50],
}) => {
  if (!pagination) return <></>;
  return (
    <TableCard.Footer
      amount={pagination?.pageSize}
      setAmount={changePageSize}
      totalEntries={pagination?.total}
      page={(pagination?.page || 1) - 1}
      onChangePage={(page: number) => goToPage(page + 1)}
      isLoading={isLoading}
      amountOptions={amountOptions}
    />
  );
};

export default PaginatedTableFooter;
